import React from 'react';
import debounce from 'debounce';
import { Select } from 'antd';

import {
    _getSearchAdmins
} from '../../services'

const { Option } = Select;

class AdminSearch extends React.PureComponent{

    render() {

        const { width, admins } = this.state;

        return (
            <Select
            showSearch
            value={this.props.value}
            placeholder={this.props.placeholder}
            style={this.props.style}
            defaultActiveFirstOption={false}
            showArrow={false}
            filterOption={false}
            onSearch={this.handleSearch}
            onChange={this.handleChange}
            notFoundContent={null}
            disabled={this.props.disabled}
          >
            {admins.map(_admin => <Option value={`${_admin.local.email}`}>{_admin.local.email}</Option>)}
          </Select>
        )

	}

	state = {
		width: 200,
		loading: false,
		admins: []
	}

	constructor(props){
		super(props);
		this.searchAdmins = debounce(this.searchAdmins, 500);
	}

    handleSearch = value => {

        if (value) {
            this.searchAdmins(value)
        } else {
            this.setState({ admins: [] });
        }
    };

    handleChange = value => {
        this.props.onChange(value)
    };

	searchAdmins = (value) => {
		_getSearchAdmins({
            searchParam: value,
            limit: 10
        })
			.then( res => {
				this.setState({
					admins: res.data.admins,
					loading: false
				})
			})
	}

}

export default AdminSearch;


// WEBPACK FOOTER //
// ./src/components/sla-discrepancies/admin-search.js